import { styled, TextField, TextFieldProps, Typography } from "@mui/material";
import { forwardRef } from "react";

type ExtendedTextFieldProps = TextFieldProps & {
  testId?: string;
};

const StyledTextField = styled(TextField)<TextFieldProps>(
  ({ theme, error }) => ({
    ...{
      "& .MuiOutlinedInput-root": {
        overflow: "hidden",
      },
      "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: error && theme.palette.error.main,
      },
    },
  })
);

const CustomizedTextField = forwardRef<
  HTMLInputElement,
  ExtendedTextFieldProps
>(
  (
    {
      id,
      name,
      label,
      value,
      onChange,
      onBlur,
      onFocus,
      disabled,
      multiline,
      rows,
      error,
      helperText,
      sx,
      InputProps,
      inputProps,
      InputLabelProps,
      required,
      placeholder,
      margin,
      maxRows,
      minRows,
      type,
      FormHelperTextProps,
      autoFocus,
      onKeyDown,
      size,
      testId,
    },
    ref
  ) => {
    return (
      <StyledTextField
        ref={ref}
        placeholder={placeholder}
        autoComplete="off"
        size={size || "small"}
        data-test-id={testId}
        autoFocus={autoFocus}
        fullWidth
        label={label}
        sx={sx}
        inputProps={inputProps}
        InputProps={{
          ...InputProps,
          endAdornment: (
            <>
              {InputProps?.endAdornment}
              {required && !label && <Typography color="red">*</Typography>}
            </>
          ),
        }}
        value={value || value === 0 ? value : ""}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        type={type ? type : "text"}
        id={id}
        name={name}
        multiline={multiline}
        rows={rows}
        error={error}
        helperText={helperText}
        margin={margin}
        maxRows={maxRows}
        minRows={minRows}
        InputLabelProps={InputLabelProps}
        required={required}
        FormHelperTextProps={FormHelperTextProps}
        onKeyDown={onKeyDown}
      />
    );
  }
);

export default CustomizedTextField;
